<template>
  <el-dialog
    title="查看视频"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    append-to-body
  >
    <div v-if="videoList && videoList.length > 0" style="height: 400px; overflow-y: auto;">
      <div v-for="(item, index) in videoList" :key="index" style="margin-bottom: 20px;">
        <video :src="item.url || item" controls style="width: 100%;"></video>
      </div>
    </div>
    <div v-else style="text-align: center; padding: 20px;">
      暂无视频
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "VideoPlayerDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    videoList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
};
</script>

<style scoped>
</style>
